import { useDiaryByIdQuery } from "@/features/diaries/api";
import EditDiary from "@/features/diaries/features/edit/components/EditDiary";
import { useDiaryCopy } from "@/features/i18n/diaryCopy";
import { createFileRoute } from "@tanstack/react-router";

const HomeEditPage = () => {
    const copy = useDiaryCopy();
    const { diaryId } = Route.useParams();
    const { data: diary } = useDiaryByIdQuery(diaryId);

    if (!diary?.diary_id) {
        return <p>{copy.noDiary}</p>;
    }

    return (
        <div className="space-y-8">
            <EditDiary diary={diary} />
        </div>
    );
};

export const Route = createFileRoute("/_app/diaries/$diaryId/home/edit")({
    component: HomeEditPage,
});
